/* ============================================
   ChatNotificationProvider — Global wrapper
   Activates chat notifications and exposes
   unread count via React context.
   ============================================ */
import { createContext, useContext } from 'react'
import { useChatNotifications } from '@/hooks/useChatNotifications'
import { useRealtimeConnection } from '@/hooks/useRealtimeEvents'

interface ChatNotificationContextValue {
  unreadCount: number
}

const ChatNotificationContext = createContext<ChatNotificationContextValue>({ unreadCount: 0 })

export function useChatUnread() {
  return useContext(ChatNotificationContext)
}

export default function ChatNotificationProvider({ children }: { children: React.ReactNode }) {
  const { unreadCount } = useChatNotifications()
  useRealtimeConnection()

  return (
    <ChatNotificationContext.Provider value={{ unreadCount }}>
      {children}
    </ChatNotificationContext.Provider>
  )
}
